var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlidesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1473_17920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23.2855C9.13386 20.5209 5.92499 18.7303 2.43772 18.2283C2.04079 18.1817 1.6742 17.9807 1.4087 17.6641C1.1432 17.3475 0.997607 16.9378 1.00003 16.514V2.71403C1.00006 2.46865 1.04974 2.22613 1.14569 2.00288C1.24165 1.77963 1.38165 1.58084 1.55623 1.41994C1.73081 1.25905 1.9359 1.13981 2.15765 1.07027C2.37939 1.00074 2.61262 0.98253 2.84156 1.01688C6.17618 1.60421 9.22671 3.36781 11.5 6.0226V23.2855Z",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 5V2.71403C21.9999 2.46865 21.9503 2.22613 21.8543 2.00288C21.7584 1.77963 21.6184 1.58084 21.4438 1.41994C21.2692 1.25905 21.0641 1.13981 20.8424 1.07027C20.6206 1.00074 20.3874 0.98253 20.1584 1.01688C16.8238 1.60421 13.7733 3.36781 11.5 6.0226V23.2855C13.8661 20.5209 17.075 18.7302 20.5623 18.2283C20.9592 18.1817 21.3258 17.9807 21.5913 17.6641C21.8568 17.3475 22.0024 16.9378 22 16.514V14",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 9.15205L17.4912 14.6608L15 15L15.3509 12.5088L20.848 7L23 9.15205Z",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1473_17920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidesIcon);
export default __webpack_public_path__ + "static/media/slides-icon.4ba6e9d1a1b81a7be428b921d8feec68.svg";
export { ForwardRef as ReactComponent };